<template>
	<v-app id="app">
		<Navigation />
		<v-main>
			<v-container fluid class="page-container">
				<router-view :key="$route.path"></router-view>
			</v-container>
		</v-main>
	</v-app>
</template>

<script>
import Navigation from "@/components/Navigation.vue";

export default {
	components: {
		Navigation,
	},
	data() {
		return {};
	},
};
</script>

<style lang="scss" scoped>
.v-main {
	.container {
		padding: 10px;
	}
}
</style>

<!-- GLOBAL STYLES -->
<style lang="scss">
@import "./sass/main.scss";

.page-container {
	height: 100%;
	background-color: #f3f4f9;
}
</style>
